
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/DashboardDoughnut/DashboardDoughnut.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./DashboardDoughnut.html');
        
        var script = require('./DashboardDoughnut.ts').default;
        module.exports = require('./DashboardDoughnut.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    